import { NO_FLIP_PREFIX } from './constants';

export const withNoFlip = (style: string | number) => {
  return `${NO_FLIP_PREFIX} ${style}`;
};
